<angular-editor id="thanks" [(ngModel)]="content" [config]="editorConfig" (ngModelChange)="contentChanged()"></angular-editor>
